import { render } from "./edit-purchases.vue?vue&type=template&id=03da173a"
import script from "./edit-purchases.vue?vue&type=script&lang=js"
export * from "./edit-purchases.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__